import React, { Component } from 'react';
import { connect } from 'react-redux';

import { HeroImage } from 'js/portfolio/components/hero_image';
import { mapValues } from 'lodash';
import $image_url from 'js/utils/image_url';

class Header extends Component {
  render() {
    const { props } = this;

    const coverImgs = mapValues(props.coverPhoto, $image_url);

    return (
      <div>
        <HeroImage
          style={{ maxHeight: '44vw' }}
          className="hero-image"
          srcSetSmall={`${coverImgs.sm} 1x, ${coverImgs.md} 2x`}
          srcSetLarge={`${coverImgs.md} 1x, ${coverImgs.xl} 2x`}
          srcFallback={coverImgs.md}
          isDirectlyFromPremiumFunnel={props.isDirectlyFromPremiumFunnel}
        />

        {props.userPhoto && (
          <div className="profile-picture-circle">
            <img src={props.userPhoto} alt="" />
          </div>
        )}

        <h1 className="site-username">{props.displayName}</h1>
      </div>
    );
  }
}

const mapStateToProps = ({ user_info }) => {
  return {
    primaryAffiliation: user_info.primary_affiliation,
    displayName: user_info.display_name,
    userPhoto: user_info.photo,
    coverPhoto: user_info.cover_photo,
  };
};
export default connect(mapStateToProps)(Header);
